import React, { useState, useEffect } from 'react'

import type { AdaptedPalette } from './adaptPalette'

import './PaletteBackground.css'

export const PaletteBackground = ({ palette }: { palette: AdaptedPalette }) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const raf = requestAnimationFrame(() => setVisible(true))
    return () => cancelAnimationFrame(raf)
  }, [])

  return (
    <div
      aria-hidden='true'
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: -1,
        pointerEvents: 'none',
        background: palette.gradientCSS,
        backgroundSize: '100% 100%, 100% 100%, 300% 300%',
        animation: 'palette-aurora 18s ease-in-out infinite',
        transform: 'translateZ(0)',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease-in',
      }}
    />
  )
}
